export const cookieController = {
    setCookie: function(cname, cvalue, milliseconds) {
        const d = new Date();
        d.setTime(d.getTime() + (milliseconds));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    /*checkCookie: function(cname) {
        let name = cname + "=";
        let cookies = document.cookie.split(';');
        for( let i = 0; i < cookies.length; i++ ) {
            let c = cookies[i];
            while(c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if(c.indexOf(name)){
                return c.substring(name.length, c.length);
            }
        }
    },*/
    getCookie: function(cname){
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}